import React, { useCallback, useEffect, useState } from 'react';
import SelectBox from '../SelectBox2';
import DateRangePickerComponent from '../DateRangeComponent';
import { Grid } from '@material-ui/core';
import AppConstants from '../../constants';
import { useStyles } from './Filter.styles';
import { RowData, SortDirection } from './DataTable';
import AutoCompleteWrapper from 'common/AutoCompleteWrapper';

interface FilterProps {
  filter: any,
  updateFilter: (filter: any) => void,
  reset: boolean,
  defaultValues: any,
  initialValues?: any;
  orderBy?: string;
  order?: SortDirection;
}

const Filter = (props: FilterProps) => {
  const classes = useStyles();
  const { filter, defaultValues, reset, updateFilter, initialValues , orderBy, order} = props;
  const [filterValue, setFilterValue] = useState(defaultValues[filter.fieldName] || "");

  const handleDateRangeChange = useCallback(
    (range: any) => {
      setFilterValue(range);
    },
    [],
  )
  const handleFilterChange = useCallback(
    (value: any) => {
      setFilterValue(value);
    },
    []
  );

  const handleAutocompleteChange = useCallback(
    (value: any) => {
      // Extract only the values from the array of objects
      const transformedValue = Array.isArray(value) 
        ? value.map((item: any) => typeof item === 'object' && item.value ? item.value : item)
        : value;
      setFilterValue(transformedValue);
    },
    []
  );

  useEffect(() => {
    updateFilter({
      key: filter.fieldName,
      value: filterValue
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue])

  useEffect(() => {
    if (reset) {
      setFilterValue(defaultValues[filter.fieldName]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reset]);

    const onApplyFilter = useCallback(
      (value: any) => {
        //setResetFilter(false);
        updateFilter({
          key: filter.fieldName,
          value: value,
          reset: false,
          fieldName: filter.fieldFullName || ''
        });
      },
      [filter, updateFilter],
    );

   const handleDateFilterChange = useCallback(
      (value: any) => {
        handleFilterChange(value);
        onApplyFilter(value);
      },
      [handleFilterChange, onApplyFilter],
    )

  const getFilter = () => {
    switch (filter.type) {
      case 'selectBox':
        return (
          <SelectBox
          handleChange={handleFilterChange}
          value={filterValue}
          reset={reset}
          id={filter.key}
          multiple={filter.multiple}
          label={filter.label}
          initialValues={initialValues}
          items={filter.items || []}
        ></SelectBox>
        );
        case 'autocomplete':
        return (
          <div className={classes.autoCompleteWrapper}>
          <AutoCompleteWrapper
            handleChange={handleAutocompleteChange}
            value={[]}
            reset={false}
            resetAll={reset}
            id={filter.key}
            multiple={filter.multiple}
            items={filter.items || []}
            label={filter.label}
            autoSelectAll={true}
            autoFocus={false}  
          />
          </div>
        );
        case 'dateRange':
          return (
            <DateRangePickerComponent
              keyId={filter.key}
              label={filter.label}
              placeholder={filter.placeholderText}
              value={filterValue}
              isTextField={filter?.isTextField ? filter.isTextField : false}
              autoUpdateInput={filter.autoUpdateInput}
              autoApply={filter.autoApply}
              maxSpan={filter.maxSpan}
              showDropdowns={filter.showDropdowns}
              linkedCalendars={filter.linkedCalendars}
              locale={{ ...filter.locale, format: AppConstants.DATE_FORMAT }}
              updateDateRange={handleDateFilterChange}
              disabled={false}
            />
          )
      default: return null;
    }
  }
  return (
    <Grid className={classes.root} item>
      { filter && filter.type ? getFilter() : null}
    </Grid>
  );
}

export default Filter;